module.exports = __webpack_public_path__ + "static/media/stedelijk.55046a2c.jpg";